import { checkModuleEnabled } from 'utils/helpers/moduleAccess';

import { MESH_LIST_TABS } from 'constants/ProjectConstants';

export const getEnabledMeshListTabItems = () =>
  Object.values(MESH_LIST_TABS)
    .map((item) => ({ id: item.id, value: item.taskType }))
    .filter(({ value }) => {
      if (value === MESH_LIST_TABS.levelUp.taskType || value === MESH_LIST_TABS.competencies.taskType) return true;

      return checkModuleEnabled(value);
    });

export const isEnabledTabItemId = (tabItemId) =>
  getEnabledMeshListTabItems().filter(({ id }) => id === tabItemId).length > 0;
